var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 64c0-35.323-28.677-64-64-64h-384c-35.323 0-64 28.677-64 64v384c0 35.323 28.677 64 64 64h384c35.323 0 64-28.677 64-64v-384z",
    fill: "#2867b2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.053,
    y: 178.67,
    width: 85.76,
    height: 257.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.51 54.28c-29.341 0-48.512 19.29-48.512 44.573 0 24.752 18.588 44.574 47.377 44.574h0.554c29.903 0 48.516-19.822 48.516-44.574-0.555-25.283-18.611-44.573-47.935-44.573z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.28 172.6c-45.49 0-65.866 25.017-77.276 42.589v-36.523h-85.738c1.137 24.197 0 257.96 0 257.96h85.737v-144.06c0-7.711 0.554-15.42 2.827-20.931 6.188-15.4 20.305-31.352 43.993-31.352 31.012 0 43.436 23.664 43.436 58.327v138.02h85.741v-147.93c0-79.237-42.305-116.1-98.72-116.1z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.7cee089830681b17c13981a1f0be79a7.svg";
export { ForwardRef as ReactComponent };